"use strict";

var _slicedToArray = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RGBColor = void 0;

var XYZColor_1 = require("./XYZColor");

var SRGBColor_1 = require("./SRGBColor");
/**
 * Represents the RGB color space.
 */


var RGBColor = /*#__PURE__*/function () {
  /**
   * Creates new RGBColor
   * @param r - Red component in the range [0, 1].
   * @param g - Green component in the range [0, 1].
   * @param b - Blue component in the range [0, 1].
   */
  function RGBColor(r, g, b) {
    _classCallCheck(this, RGBColor);

    this.values = [r, g, b];
  }
  /**
   * The red-component of the color.
   */


  _createClass(RGBColor, [{
    key: "toArray",

    /**
     * Return a copy of color values in array format as [r, g, b].
     */
    value: function toArray() {
      // copy
      return this.values.map(function (v) {
        return v;
      });
    }
    /**
     * Trasforms color to the XYZ format.
     */

  }, {
    key: "toXYZ",
    value: function toXYZ() {
      var _this$values = _slicedToArray(this.values, 3),
          r = _this$values[0],
          g = _this$values[1],
          b = _this$values[2];

      var x = 0.4124 * r + 0.3576 * g + 0.1805 * b;
      var y = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      var z = 0.0193 * r + 0.1192 * g + 0.9505 * b;
      return new XYZColor_1.XYZColor(x, y, z);
    }
    /**
     * Trasforms color to the sRGB values.
     */

  }, {
    key: "toSRGB",
    value: function toSRGB() {
      var values = this.values.map(function (v) {
        if (v < 0.0031308) {
          return 12.92 * v;
        } else {
          return 1.055 * Math.pow(v, 1 / 2.4) - 0.055;
        }
      });
      return new SRGBColor_1.SRGBColor(values[0], values[1], values[2]);
    }
    /**
     * Trasforms color to the CIE LAB format.
     */

  }, {
    key: "toLAB",
    value: function toLAB() {
      return this.toXYZ().toLAB();
    }
  }, {
    key: "r",
    get: function get() {
      return this.values[0];
    }
    /**
     * The green-component of the color.
     */

  }, {
    key: "g",
    get: function get() {
      return this.values[1];
    }
    /**
     * The blue-component of the color.
     */

  }, {
    key: "b",
    get: function get() {
      return this.values[2];
    }
  }]);

  return RGBColor;
}();

exports.RGBColor = RGBColor;